import { S3 } from '~models/s3'

const getMimeType = (file: File, resourceType: S3.ResourceType) => {
  const mimeType = S3.MimeType[file.type as unknown as keyof typeof S3.MimeType]

  if (resourceType === S3.ResourceType.QUESTION_VIDEO) {
    return mimeType
  }

  // 안드로이드 갤럭시 S8에서 갤러리에서 선택한 이미지의 type이 ''로 들어오는 이슈가 있어서 default로 image/png로 설정
  return mimeType || S3.MimeType['image/png']
}

const getFileTypes = async (files: File[], resourceType: S3.ResourceType) => {
  if (!files.length) {
    return []
  }

  return files.map(file => {
    const fileType = {
      resource_type: resourceType,
      mime_type: getMimeType(file, resourceType),
    }

    return new S3.PreSignedPost.Request(fileType)
  })
}

export default getFileTypes
